import React, { Component } from 'react'

export default class PageHeader extends Component {
  render() {
    return (
      <div style={{
        padding: '16px',
        marginBottom: '10px'
      }}>
        <span style={{
          display: 'block',
          fontSize: '24px',
          lineHeight: '36px'
        }}>
          <span>{this.props.title}</span>
        </span>
        {this.props.children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PaperHeader.js